export default defineNuxtPlugin(() => {
  if (isSearchCrawler(navigator.userAgent)) return
  if (!hasAcceptedConsent()) return

  const savedLocale = getSavedLocale()
  const targetLocale = savedLocale ?? detectFromCountry(
    useCookie<string | null>('archestor-country', { path: '/' }).value ?? undefined
  )
  const targetPath = localePath(targetLocale)

  if (window.location.pathname === targetPath) return

  const route = useRoute()
  navigateTo({ path: targetPath, query: route.query, hash: route.hash }, { replace: true })
})